var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"md:mb-8 lg:mb-16"},[_c('div',{staticClass:"max-w-1440 mx-auto px-4 md:px-8 lg:px-16"},[_c('ProductsHeader'),_c('items-header')],1),_c('items')],1)}
var staticRenderFns = []

export { render, staticRenderFns }